<template>
  <v-card flat class="container--fluid">
    <v-card flat class="v-card__container bg-gray zindex-1">
      <h4>Handledarinstruktioner</h4>
    </v-card>

    <v-tabs v-model="tab" class="">
      <v-tab key="1" class="text-uppercase bold">INSTRUKTIONSTEXTER</v-tab>
      <v-tab key="2" class="text-uppercase bold">Ändringsdatum och sammanfattning av ändringar</v-tab>
      <v-tab key="3" class="text-uppercase bold">AKTUELL PUBLICERAD VERSION</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item key="1">
        <EditInstructions :tab="tab" />
      </v-tab-item>

      <v-tab-item key="2">
        <EditCommit :tab="tab" />
      </v-tab-item>

      <v-tab-item key="3">
        <PreviewInstructions :tab="tab" />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import {RulesMixin} from '@/components/mixins'
import EditInstructions from '@/components/admin/instructions/EditInstructions.vue'
import EditCommit from '@/components/admin/instructions/EditCommit.vue'
import PreviewInstructions from '@/components/admin/instructions/PreviewInstructions.vue'

// @group Common
// InstructorInstructions component
export default {
  name: 'InstructorInstructions',

  mixins: [RulesMixin],

  components: {
    EditInstructions,
    EditCommit,
    PreviewInstructions
  },

  data: () => ({
    tab: null
  }),

  created() {},

  computed: {},

  methods: {}
}
</script>

<style lang="scss" scoped>
</style>